import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { DAILY_FORECAST_REPORT_ENDPOINT } from '../endpoint';
import { DailyForecastReportRequestModel } from '../models/DailyForecastReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: DailyForecastReportRequestModel): Promise<void> => {
    return await axios
      .get(`${DAILY_FORECAST_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'daily-forecast-report',
        });
      });
  };
